<template>
  <form @submit.prevent="searchFor()" method="post" class="d-flex">
    <input type="search" placeholder="Suchbegriff eingeben" v-model="searchVal" />
    <button type="submit" class="btn btn-primary" id="search-button--blog">
      <span class="d-none"> Suche </span>
      <span class="icon-search"></span>
    </button>
  </form>
</template>

<script>
import { useRouter, ref } from '@nuxtjs/composition-api';

export default {
  name: 'BlogSearchBar',
  props: {
    query: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const router = useRouter();
    const searchVal = ref(props.query || '');
    const searchFor = async () => {
      const q = searchVal.value;
      await router.push({ path: '/blog/s/' + q });
    };
    return {
      searchFor,
      searchVal,
    };
  },
};
</script>

<style lang="scss" scoped>
input[type='search'] {
  height: 100%;
  width: 100%;
  background: #fff;
  border: 0 none;
  padding: 15px 20px;
}
#search-button--blog {
  padding: 13px;
  position: relative;
  top: 0;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  [class^='icon-'] {
    font-size: 22px;
  }
}
</style>
